import React from 'react';
import { IoArrowBack, IoArrowForward } from "react-icons/io5"

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  // If totalPages is not a valid number or <= 1, don't show pagination
  if (!totalPages || isNaN(totalPages) || totalPages <= 1) return null;

  // Handle page click
  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  // Generate page numbers with ellipses
  const getPageNumbers = () => {
    const pageNumbers = [];
    const delta = 2; 

    for (let i = 1; i <= totalPages; i++) {
      if (
        i === 1 || 
        i === totalPages || 
        (i >= currentPage - delta && i <= currentPage + delta) 
      ) {
        pageNumbers.push(i);
      } else if (
        (i === currentPage - delta - 1 && i > 1) ||
        (i === currentPage + delta + 1 && i < totalPages)
      ) {
        pageNumbers.push('...');
      }
    }

    // Remove consecutive ellipses (if any)
    return pageNumbers.filter((item, index) => {
      if (item === '...' && pageNumbers[index - 1] === '...') return false;
      return true;
    });
  };

  const pageNumbers = getPageNumbers();

  return (
    <div className="bg-white border-t border-gray-200 p-3 flex flex-row items-center justify-between w-full dark:bg-dark dark:border-border-dark">
      <button
        type="button"
        onClick={() => handlePageClick(currentPage - 1)}
        disabled={currentPage === 1}
        className={`px-4 py-1.5 flex flex-row items-center gap-2 bg-gray-100 hover:bg-gray-200 border-md text-black border rounded-lg font-light text-sm border-gray-300 dark:bg-secondaryDark dark:border-border-dark dark:text-white ${currentPage === 1 ? 'opacity-50 cursor-not-allowed' : ''}`}
      >
        <IoArrowBack size={16} />
        Previous
      </button>
      <div className="">
        <ul className="flex flex-row items-center gap-0.5">
          {pageNumbers.map((page, index) => (
            <li key={index}>
              {page === '...' ? (
                <span className="px-3 py-2 text-gray-500 dark:text-gray-400">...</span>
              ) : (
                <button
                  type="button"
                  className={`mx-1 flex h-9 w-9 items-center justify-center rounded-full p-0 text-sm transition duration-150 ease-in-out dark:bg-secondaryDark dark:border-border-dark dark:text-white ${currentPage === page ? "bg-gray-100 font-bold border border-gray-300" : "bg-transparent text-blue-gray-500 hover:bg-gray-50"}`}
                  onClick={() => handlePageClick(page)}
                >
                  {page}
                </button>
              )}
            </li>
          ))}
        </ul>
      </div>
      <button
        type="button"
        onClick={() => handlePageClick(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={`px-4 py-1.5 flex flex-row items-center gap-2 bg-gray-100 hover:bg-gray-200 border-md text-black border rounded-lg font-light text-sm border-gray-300 dark:bg-secondaryDark dark:border-border-dark dark:text-white ${currentPage === totalPages ? 'opacity-50 cursor-not-allowed' : ''}`}
      >
        Next
        <IoArrowForward size={16} />
      </button>
    </div>
  );
};

export default Pagination;
